import { Component, Input } from '@angular/core';

import { ModalService } from '../modal.service';
import { AbstractModal } from '../AbstractModal';

@Component({
  selector: 'ls-fdm-black-box-modal',
  templateUrl: './fdm-black-box-modal.component.html'
})
export class FdmBlackBoxModalComponent extends AbstractModal {
  @Input()
  public data: any;
  constructor(private modal: ModalService) {
    super();
  }

  public close(): void {
    this.modal.close();
  }
}
